import { render, staticRenderFns } from "./SportSingleResults.vue?vue&type=template&id=777797e6"
import script from "./SportSingleResults.vue?vue&type=script&lang=js"
export * from "./SportSingleResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports